import { render, staticRenderFns } from "./ChangelogTable.vue?vue&type=template&id=94787bb6&scoped=true&"
import script from "./ChangelogTable.vue?vue&type=script&lang=js&"
export * from "./ChangelogTable.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogTable.vue?vue&type=style&index=0&id=94787bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94787bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94787bb6')) {
      api.createRecord('94787bb6', component.options)
    } else {
      api.reload('94787bb6', component.options)
    }
    module.hot.accept("./ChangelogTable.vue?vue&type=template&id=94787bb6&scoped=true&", function () {
      api.rerender('94787bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/changelog/ChangelogTable.vue"
export default component.exports